export enum TaskType {
  Stopover = "Stopover",
  BundledStopover = "BundledStopover",
  Internal = "Internal",
}
